module.exports = __webpack_public_path__ + "img/regular-logo.6264050f.png";